import { Component, OnInit, Inject, Injectable, ViewChild, ElementRef } from '@angular/core';
import { DOCUMENT } from '@angular/platform-browser';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { APP_BASE_HREF,Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { Cookie } from 'ng2-cookies/ng2-cookies';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LocationsService } from '../../../_services/locations/locations.service';
import {  } from 'googlemaps';

@Component({
  selector: 'app-locationedit',
  templateUrl: './locationedit.component.html',
  styleUrls: ['./locationedit.component.css'],
  providers:[LocationsService,Location, {provide: LocationStrategy, useClass: PathLocationStrategy}]
})
export class LocationeditComponent implements OnInit {
  @ViewChild('gmap') gmapElement: any;
  map: google.maps.Map;
  marker: google.maps.Marker;
  lat:any = {};
  lng:any = {};
  locationid: number;
  cookies: Object;
  data: any = {};
  serviceprovider: any;
  countries: any;
  brands: any;
  domain:any;

  constructor(
    @Inject(DOCUMENT) private document: any,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private locationsService:LocationsService,
    private location: Location
    ) {
      this.domain = this.document.location.origin;
      this.activatedRoute.params.subscribe((params: Params) => {
      this.locationid = params['id'];
      if (this.locationid != undefined) {
        Cookie.set('locationEdit', '1');
      }
    });

    this.locationsService.editLocations(this.locationid).subscribe(
      res => {
       this.data = res;
       console.log(this.data, 50090);
       this.setGoogleMapLocationMarkerForResidence(this.data.latitude, this.data.longitude, this.data.company_name, this.data);
       var brands_l = this.data.brand_id;
       this.data.brand_id = brands_l.split(',');

      }
    );

    this.locationsService.getServiceProviderType().subscribe(
      res => {
        this.serviceprovider = res;
      }
    );

    this.locationsService.getcountries().subscribe(
      res => {
        this.countries = res;
      }
    );

    this.locationsService.getbrands().subscribe(
      res => {
        this.brands = res;
      }
    );
  }

  ngOnInit() {

  }

  @ViewChild('update_location') update_location:ElementRef;

    editLocation() {
      this.update_location.nativeElement.disabled = true;
      this.locationsService.saveLocations(this.data).subscribe(
        res => {
          this.router.navigate(['locations']);
          //console.log(this.domain);
          // if(this.domain == "http://localhost:4200"){
          //   window.location.href="http://localhost:4200/#/locations";
          // }else{
          //   window.location.href="http://deutz-angular-four.azularcdev.com/#/locations";
          // }

        }
      );
    }
  
  	white_space(id: any)
	{
		if($("#"+id).val() == " "){
			//$("#"+id).trim();
		}
	}

  setGoogleMapLocationMarkerForResidence(latitude, longitude, residenceName, data) {
    if(latitude != ''
      && latitude != null
      && !isNaN(latitude)
      && longitude != ''
      && longitude != null
      && !isNaN(longitude)) {

      var mapProp = {
        center: new google.maps.LatLng(latitude, longitude),
        zoom: 8,
        mapTypeId: google.maps.MapTypeId.ROADMAP
      };

      this.map = new google.maps.Map(this.gmapElement.nativeElement, mapProp);

      this.marker = new google.maps.Marker({
        position: new google.maps.LatLng(latitude, longitude),
        map: this.map,
        draggable: true,
        title: residenceName
      });

       // adds a listener to the marker
            // gets the coords when drag event ends
            // then updates the input with the new coords
            google.maps.event.addListener(this.marker, 'dragend', function (evt) {
              // $("#txtLat").val(evt.latLng.lat().toFixed(6));
              // $("#txtLng").val(evt.latLng.lng().toFixed(6));
              this.map.panTo(evt.latLng);
              console.log(evt.latLng.lat().toFixed(6));
              console.log(evt.latLng.lng().toFixed(6));
           
              data.lat = evt.latLng.lat().toFixed(6);
              data.lng = evt.latLng.lng().toFixed(6);
          });
          // centers the map on markers coords
          //this.map.setCenter(this.marker.position);
          // adds the marker on the map
          this.marker.setMap(this.map);

    } else {
      //Display General Map If Latitude & Longitude is not set
      var mapProp = {
        center: new google.maps.LatLng(40.7128, -73.935242),
        zoom: 4,
        mapTypeId: google.maps.MapTypeId.ROADMAP
      };

      this.map = new google.maps.Map(this.gmapElement.nativeElement, mapProp);
    }

     

  }

  setMapType(mapTypeId: string) {
    this.map.setMapTypeId(mapTypeId);
  }

}



// WEBPACK FOOTER //
// C:/wamp64/www/duetz.repos/angular4/src/app/_components/locations/locationedit/locationedit.component.ts